import React, { FC } from 'react'

interface ReliabilityAIBusinessProps {
    aiBusinessData: any
}

const ReliabilityAIBusiness: FC<ReliabilityAIBusinessProps> = ({ aiBusinessData }) => {
    return (
        <div>
            <div className='grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 md:gap-12 p-4 sm:p-8 md:p-20 pt-4 sm:pt-8 md:pt-16 px-4 sm:px-8 md:px-36 bg-darkGreyPrimary'>
                {aiBusinessData.ReliabilityAiBusinessesData.map((reliable: any) => {
                    return (
                        <div className={`flex flex-col items-start justify-start p-4 sm:p-6 md:p-8 pt-3 sm:pt-4 md:pt-6 relative rounded-lg sm:rounded-xl md:rounded-2xl border border-[#262626]`}
                            style={{
                                background: `linear-gradient(267.5deg, #1A1A1A 40.67%, rgba(26, 26, 26, 0) 99.81%), linear-gradient(115.88deg, ${reliable.bgColor}30 -42.63%, rgba(152, 255, 18, 0) 41.71%)`
                            }}>
                            <div className={`text-lg sm:text-xl text-start font-semibold pb-1 sm:pb-2 text-white `}>{reliable.title}</div>
                            <div className={`text-lightGrey text-start text-sm sm:text-base md:text-m pt-1 sm:pt-2 border-t-2 w-full border-${reliable.color}`}>{reliable.subtitle}</div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default ReliabilityAIBusiness
